module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s04-3_s-b7d02603624304368778ad8faf8b6e25.png";